/** @format */
import { DegreeProgramme, GroupingModule, Module, StudyModule } from 'common-typescript/types';

export function isStudyModule(module: Module): module is StudyModule {
    return module?.type === 'StudyModule';
}

export function isDegreeProgramme(module: Module): module is DegreeProgramme {
    return module?.type === 'DegreeProgramme';
}

export function isGroupingModule(module: Module): module is GroupingModule {
    return module?.type === 'GroupingModule';
}
